export const xmlNamespace = "http://www.w3.org/2000/svg"
